<template>

<app-content>

	<app-content-head title="Audit" subtitle="See the full audit history for all revenue and expenses." />

	<app-content-body>

		<app-content-summary>

			<app-content-summary-item label="Payments" :no-plural="true" :grow="true" :value="$convention.count.billing.sales_total | formatMoney" />
			
			<app-content-summary-item label="Refunds" :no-plural="true" :grow="true" :value="$convention.count.billing.refunds_total | formatMoney('-')" />
			
			<app-content-summary-item label="Credits" :no-plural="true" :grow="true" :value="$convention.count.billing.credits_total | formatMoney('+')" />
			
			<app-content-summary-item label="Fees" :is-end="true" :no-plural="true" :grow="true" :value="$convention.count.billing.platform_total | formatMoney('-')" />
			
			<app-content-summary-item label="Net Revenue" theme="blue" :is-start="true" :is-metric="true" :no-plural="true" :grow="true" :value="$convention.count.billing.net_total | formatMoney" />

		</app-content-summary>

        <app-content-box :tabs="tabs" :not-padded="true">

            <template v-slot:payments>

                <com-payments />

            </template>

            <template v-slot:refunds>

                <com-refunds />

            </template>

            <template v-slot:credits>

                <com-credits />

            </template>

            <template v-slot:fees>

                <com-fees />

            </template>

        </app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import comPayments from './conventionbillingaudit/Payments'
import comCredits from './conventionbillingaudit/Credits'
import comRefunds from './conventionbillingaudit/Refunds'
import comFees from './conventionbillingaudit/Fees'

export default {

	components: {
        'com-payments': comPayments,
        'com-credits': comCredits,
        'com-refunds': comRefunds,
        'com-fees': comFees
	},

    computed: {
    
        tabs: function() {
        
            return [
                { name: 'payments', text: 'Payments', count: this.$con.count.billing.sales_count },
                { name: 'refunds', text: 'Refunds', count: this.$con.count.billing.refunds_count },
                { name: 'credits', text: 'Credits', count: this.$con.count.billing.credits_received },
                { name: 'fees', text: 'Fees', count: this.$con.count.billing.charges}
            ]

        }

    }

}

</script>

<style scoped>

.summary-wrapper {
	display: flex;
}

</style>